import {
  Button,
  Card,
  Checkbox,
  Dialog,
  FormControlLabel,
} from '@mui/material';
import * as React from 'react';
import useAppDispatch from '@data/useAppDispatch';
import { publishContent } from '@data/contents/Contents.thunk';
import { LoadingButton } from '@mui/lab';

export interface ContentPublishModalProps {
  contentId: string;
  onClose: () => void;
}

export const ContentPublishModal = (props: ContentPublishModalProps) => {
  const { contentId, onClose } = props;
  const [notifyCommunity, setNotifyCommunity] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);

  const dispatch = useAppDispatch();

  const handlePublish = () => {
    setIsLoading(true);
    dispatch(
      publishContent({
        id: contentId,
        notifyCommunity,
      }),
    )
      .then(() => {
        onClose();
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  return (
    <Dialog open onClose={onClose}>
      <Card className="pt-10 w-[371px] flex-col-center p-[20px]">
        <div className="w-full text-lg font-normal leading-normal text-left text-brand-primary font-['Roboto']">
          Publish Content
        </div>
        <div className="w-full max-h-full mt-2">
          <p className="m-0 text-base font-bold text-black leading-[21px] font-['Roboto']">
            Please confirm that you want to publish this content.
          </p>
          <FormControlLabel
            className="flex w-full mt-4"
            componentsProps={{
              typography: {
                className:
                  "text-sm font-normal leading-normal text-on-primary font-['Roboto']",
              },
            }}
            control={
              <Checkbox
                checked={notifyCommunity}
                onChange={(e) => setNotifyCommunity(e.target.checked)}
              />
            }
            label="Notify the community members."
          />
        </div>
        <div className="flex justify-center mt-[30px]">
          <Button
            onClick={onClose}
            variant="outlined"
            color="primary"
            className="w-[130px] h-[40px] !mr-[10px] !ml-[10px]"
            disabled={isLoading}
          >
            CANCEL
          </Button>
          <LoadingButton
            onClick={handlePublish}
            className="w-[130px] h-[40px] !mr-[10px] !ml-[10px]"
            variant="contained"
            color="primary"
            loading={isLoading}
          >
            CONFIRM
          </LoadingButton>
        </div>
      </Card>
    </Dialog>
  );
};
